var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"tab"},_vm._l((_vm.tabList),function(item){return _c('div',{key:item,class:_vm.activeTab === item ? 'active' : '',on:{"click":function($event){_vm.activeTab = item}}},[_vm._v("\n      "+_vm._s(item)+"\n    ")])}),0),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }